import React from "react";
import { Grid, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function StepHeader({ title, onBack, palette }) {
    return (
        <Grid xs={12} item container alignItems="center" justifyContent="center" position="relative" padding={2}>
            {onBack && (
                <IconButton onClick={onBack} sx={{ position: "absolute", left: 0, width: { xs: 48, md: 56 }, height: { xs: 48, md: 56 }, padding: 0 }}>
                    <ArrowBackIcon sx={{ fontSize: { xs: 28, md: 34 } }} />
                </IconButton>
            )}
            <Typography variant="h1" fontWeight={500} color={palette.primary.main}>{title}</Typography>
        </Grid>
    );
}
